/**
 * useEquipmentUnitsByType — STORY-1306 Phase 2 slice B (type-editor units-tab).
 * A típushoz tartozó EquipmentUnit-ok lean listája (GET /equipment-units?typeId=).
 */

import { listEquipmentUnitsByType, type EquipmentUnitListItem } from '@/api/equipment-unit';
import { useQuery } from '@tanstack/react-query';

export function useEquipmentUnitsByType(typeId: string | null): {
  units: EquipmentUnitListItem[];
  isLoading: boolean;
  isError: boolean;
} {
  const query = useQuery({
    queryKey: ['equipment-units', 'by-type', typeId],
    queryFn: () => listEquipmentUnitsByType(typeId as string),
    enabled: typeId !== null && typeId.length > 0,
  });
  return {
    units: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
